import React, { useState } from 'react'
import PostUploadsBlock from '../Posts/PostUploadsBlock/PostUploadsBlock';
import AudienceModal from './Modals/AudienceModal';

export default function QuickView({post, team, postSkin, proceed, availableAudiences, user, groupPost, users, saving}) {
  const [openAudience, setopenAudience] = useState(false)
  const showAudience = (audience) => {
    if (!audience || audience.length < 1) return 'All attached users';

    return audience.map(audience => audience.name).join(', ');
  }

  const saveData = (data) => {
    if (proceed(data)) {
      setopenAudience(false)
    }
  }


  return (
    <div>
      <div className='row'>
        <div className='col-md-12'>
            <p> <strong> Title: </strong> {post.title} </p>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12'>
            <p> <strong> Content: </strong> {post.content} </p>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12'>
            <p> <strong> From: </strong> {post.owner.name} </p>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12'>
            <p> <strong> Audience: </strong> {showAudience(post.audience)} 
              <button className='btn btn-primary btn-sm' style={{display: 'inline-block', marginLeft: '50px'}} onClick={() => setopenAudience(true)}>Modify</button>
            </p>
        </div>
      </div>

      {post.post_type == 'project' &&
        <div className='row'>
          <div className='col-md-12'>
            <p><strong>Post Type: </strong> {post.public_project_audience ? 'Public' : 'Private'} {team.project_title.toLowerCase()} post</p>
          </div>
        </div>
      }

      {post.files && post.files.length > 0 &&
        <div className='row'>
          <div className='col-md-12'>
            <p><strong>Media Files</strong></p>
            <PostUploadsBlock uploads={post.files}/>
          </div>
        </div>
      }

      {openAudience &&
        <AudienceModal 
          post={post}
          save={(data) => saveData(data)}
          close={() => setopenAudience(false)}
          postSkin={postSkin}
          availableAudiences={availableAudiences}
          user={user}
          team={team}
          saving={saving}
        />
      }
    </div>
  )
}
